/* eslint-disable promise/param-names */
import * as authTypes from '@/store/actions/auth'
import * as userTypes from '@/store/actions/user'
import * as appTypes from '@/store/actions/app'
import * as api from '@/utils/api'

const state = {
  status: null,
  hasLoadedOnce: false,
  logged: false
}

const getters = {
  [authTypes.AUTH_AUTHENTICATED]: state => state.logged,
  [authTypes.AUTH_STATUS]: state => state.status
}

const actions = {
  [authTypes.AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(authTypes.AUTH_REQUEST)
      setTimeout(function () {
        api.call({access: api.ACCESS_AUTHENTICATION, url: '/auth/login', method: 'POST', data: user})
          .then(resp => {
            dispatch(`${userTypes.USER_NAMESPACE}/${userTypes.USER_REQUEST}`, resp, {root: true})
            dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_MENU}`, { }, {root: true})
            commit(authTypes.AUTH_SUCCESS)
            resolve(resp)
          })
          .catch(err => {
            localStorage.removeItem('user-token')
            reject(err)
            setTimeout(function () {
              if (err.response) {
                commit(authTypes.AUTH_ERROR, {err: err.response.status + ''})
              } else {
                commit(authTypes.AUTH_ERROR, {err: {response: {status: 500}}})
              }
            }, 500)
          })
      }, 500)
    })
  },
  [authTypes.AUTH_REQUEST_LOADING]: ({commit, dispatch}) => {
    commit(authTypes.AUTH_REQUEST)
  },
  [authTypes.AUTH_FIRST_CHECK_LOGGED]: ({commit, dispatch}, to) => {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem('user-token') && localStorage.getItem('user-token') !== '') {
        commit(authTypes.AUTH_REQUEST)
        api.call({access: api.ACCESS_AUTHENTICATION, url: '/auth/profile', method: 'POST'})
          .then(resp => {
            dispatch(`${userTypes.USER_NAMESPACE}/${userTypes.USER_REQUEST}`, resp, {root: true})
            dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_MENU}`, to, {root: true})
            commit(authTypes.AUTH_SUCCESS)
            resolve(resp)
          })
          .catch(err => {
            localStorage.removeItem('user-token')
            // no mostrem missatge d'error
            commit(authTypes.AUTH_SUCCESS)
            reject(err)
          })
      }
    })
  },
  [authTypes.AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('user-token')
      commit(authTypes.AUTH_LOGOUT)
      dispatch(`${userTypes.USER_NAMESPACE}/${authTypes.AUTH_LOGOUT}`, { }, {root: true})
      commit(authTypes.AUTH_SUCCESS)
      resolve()
    })
  },
  [authTypes.AUTH_SUCCESS]: ({commit, dispatch}) => {
    commit(authTypes.AUTH_SUCCESS)
  },
  [authTypes.AUTH_STATUS_ERROR]: ({commit, dispatch}, error) => {
    if (error.response) {
      commit(authTypes.AUTH_STATUS_ERROR, {err: error.response.status + ''})
    }
  }
}

const mutations = {
  [authTypes.AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [authTypes.AUTH_SUCCESS]: (state) => {
    state.status = 'success'
    state.hasLoadedOnce = true
    state.logged = (localStorage.getItem('user-token') && localStorage.getItem('user-token') !== '')
  },
  [authTypes.AUTH_ERROR]: (state, {err}) => {
    state.status = err
    state.hasLoadedOnce = true
    state.logged = false
  },
  [authTypes.AUTH_STATUS_ERROR]: (state, {err}) => {
    state.status = err
  },
  [authTypes.AUTH_LOGOUT]: (state) => {
    state.logged = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js